// removed by extract-text-webpack-plugin
module.exports = {"flexContainer":"InspCarousel__flexContainer___2D52U","carouselHeader":"InspCarousel__carouselHeader___2w6qq","mainCarouselBody":"InspCarousel__mainCarouselBody___1j412","mainCarouselBodyLeads":"InspCarousel__mainCarouselBodyLeads___1uTZe","slider":"InspCarousel__slider___zGfbX","slider-decorator-0":"InspCarousel__slider-decorator-0___gMWVh","ieCarouselHeader":"InspCarousel__ieCarouselHeader____Lg2C InspCarousel__carouselHeader___2w6qq","ieMainCarouselBody":"InspCarousel__ieMainCarouselBody___JwjV1 InspCarousel__mainCarouselBody___1j412","footerPlaceholder":"InspCarousel__footerPlaceholder___1j7MO"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/InspCarousel/InspCarousel.css
// module id = 1014
// module chunks = 0